export default __webpack_public_path__ + "static/howFWAWorksStep3-436ec797148dac7e322999e39dda66d2.png";